enum FileType {
  All,
  Picture,
  Document,
  Video,
  Audio,
  Others,
}
export { FileType };
